import { Container } from './Container/Container';
import { FC } from 'react';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { Presentation } from './Presentation/Presentation';
import { SnapshotOut } from 'mobx-state-tree';
import { observer } from 'mobx-react';

export interface AnswerSelectWithRadioProps {
  question: SnapshotOut<IQuestionModel>;
  onNext?: () => void;
}

const AnswerSelectWithRadio: FC<AnswerSelectWithRadioProps> = ({
  question,
  onNext,
}) => {
  console.log('Render AnswerSelectWithRadio');
  return (
    <Container
      question={question}
      onNext={onNext}
    >
      {state => (
        <Presentation
          valueSonar={state.valueSonar}
          importance={state.importance}
          labels={state.labels}
          onSmileyPress={state.onSmileyPress}
          onImportanceChange={state.onImportanceChange}
        />
      )}
    </Container>
  );
};

export default observer(AnswerSelectWithRadio);
